import { useTranslation } from "react-i18next";
import { useState } from "react";

export default function Faqs() {
    const { t } = useTranslation();
    const faqItems = t("faqItems", { returnObjects: true }) as {
        q: string;
        a: string;
    }[];

    const [openIndex, setOpenIndex] = useState<number | null>(null);

    return (
        <div className="mx-auto max-w-[885px] px-4 py-[60px]">
            <h2 className="mb-8 text-center text-[28px] font-medium text-[rgba(23,23,23,1)]">
                {t("faqs-title")}
            </h2>

            <div className="space-y-4">
                {faqItems.map((item, i) => (
                    <div
                        key={i}
                        className="rounded-lg border border-gray-200 p-4 shadow-sm"
                    >
                        <button
                            className="flex w-full justify-between text-left font-semibold text-gray-800"
                            onClick={() =>
                                setOpenIndex(openIndex === i ? null : i)
                            }
                        >
                            {item.q}
                            <span>{openIndex === i ? "−" : "+"}</span>
                        </button>

                        {openIndex === i && (
                            <p className="mt-2 leading-relaxed text-gray-600">
                                {item.a}
                            </p>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
